// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeOauthGoogleLinkBody = {
  idToken: string;
};

export type typeOauthGoogleLinkOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { google: { isLinked: boolean; linkedAt: string } };
};

export type typeOauthGoogleLinkOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOauthGoogleLinkOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOauthGoogleLinkOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaOauthGoogleLinkBody = {
  type: "object",
  properties: { idToken: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["idToken"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createOauthGoogleLink(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaOauthGoogleLinkBody);
  }

  return async function postOauthGoogleLink(
    payload: typeOauthGoogleLinkBody,
  ): Promise<typeOauthGoogleLinkOutput200 | typeOauthGoogleLinkOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postOauthGoogleLink" failed before calling the network. #abea1c5d22d1`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#abea1c5d22d1" },
        },
        data: null,
      } as typeOauthGoogleLinkOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/oauth/google-link`,
      httpMethod: "POST",
      options,
    })) as typeOauthGoogleLinkOutput200 | typeOauthGoogleLinkOutput400;
  };
}
